import React from 'react';
import { motion } from 'framer-motion';
import { RocketLaunchIcon } from '@heroicons/react/24/outline';

const GTMv2Slide01Title: React.FC = () => {
  return (
    <div className="flex flex-col h-full px-16 py-12">
      {/* Top section: Logo + Title */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-8"
      >
        <span className="relative inline-block mb-4">
          <span
            className="absolute inset-0 text-8xl font-black text-[#06b6d4] blur-2xl opacity-40"
            aria-hidden="true"
          >
            Lumen8
          </span>
          <span className="relative text-8xl font-black bg-gradient-to-r from-[#0ea5e9] to-[#06b6d4] bg-clip-text text-transparent">
            Lumen8
          </span>
        </span>
        <h1 className="text-4xl font-bold text-white mb-2">Go-To-Market Strategy</h1>
        <p className="text-xl text-[#64748b]">36-Month Growth Plan • January 2026</p>
      </motion.div>

      {/* Middle section: Dual strategy + Seed round */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="flex-1 flex items-center justify-center"
      >
        <div className="flex items-center gap-8">
          {/* B2B Box */}
          <div
            className="px-8 py-6 rounded-2xl text-center min-w-[200px]"
            style={{
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(16, 185, 129, 0.05) 100%)',
              border: '2px solid rgba(16, 185, 129, 0.4)',
            }}
          >
            <div className="text-4xl font-black text-[#10b981] mb-1">B2B</div>
            <div className="text-lg text-white font-medium">Independent Schools</div>
            <div className="text-sm text-[#64748b] mt-1">High-touch, consultative</div>
          </div>

          <div className="text-4xl text-[#334155] font-light">+</div>

          {/* B2C Box */}
          <div
            className="px-8 py-6 rounded-2xl text-center min-w-[200px]"
            style={{
              background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.2) 0%, rgba(14, 165, 233, 0.05) 100%)',
              border: '2px solid rgba(14, 165, 233, 0.4)',
            }}
          >
            <div className="text-4xl font-black text-[#0ea5e9] mb-1">B2C</div>
            <div className="text-lg text-white font-medium">Aspirational Parents</div>
            <div className="text-sm text-[#64748b] mt-1">High-velocity, digital</div>
          </div>

          {/* Arrow */}
          <div className="text-3xl text-[#334155]">→</div>

          {/* Seed Round Box - Prominent */}
          <div
            className="px-10 py-6 rounded-2xl text-center relative overflow-hidden"
            style={{
              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(14, 165, 233, 0.2) 100%)',
              border: '2px solid rgba(139, 92, 246, 0.6)',
              boxShadow: '0 0 40px rgba(139, 92, 246, 0.3)',
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-[#8b5cf6]/10 to-[#0ea5e9]/10 animate-pulse" />
            <div className="relative">
              <div className="flex items-center justify-center gap-2 mb-2">
                <RocketLaunchIcon className="w-5 h-5 text-[#8b5cf6]" />
                <span className="text-sm font-semibold text-[#a78bfa] uppercase tracking-wider">Seed Round</span>
              </div>
              <div className="text-4xl font-black text-white">$1.2M – $2M</div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Bottom section: Value props */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="mt-auto"
      >
        <div
          className="rounded-2xl px-12 py-6"
          style={{
            background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.8) 0%, rgba(30, 41, 59, 0.4) 100%)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <div className="flex items-center justify-center gap-12">
            <div className="flex items-center gap-3">
              <div className="w-3 h-3 rounded-full bg-[#10b981]" />
              <span className="text-lg text-[#e2e8f0]">~3,500 Independent Schools</span>
            </div>
            <div className="h-6 w-px bg-[#334155]" />
            <div className="flex items-center gap-3">
              <div className="w-3 h-3 rounded-full bg-[#0ea5e9]" />
              <span className="text-lg text-[#e2e8f0]">~4M Australian Students</span>
            </div>
            <div className="h-6 w-px bg-[#334155]" />
            <div className="flex items-center gap-3">
              <div className="w-3 h-3 rounded-full bg-[#f59e0b]" />
              <span className="text-lg text-[#e2e8f0]">Year 3 to 12 Initial Focus</span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default GTMv2Slide01Title;
